var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-panel d-flex justify-content-between" },
    [
      _c(
        "div",
        { staticClass: "filter-control", on: { click: _vm.onOpenCloseFilter } },
        [
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            _c("div", [
              _c(
                "a",
                {
                  staticClass: "text-secondary",
                  attrs: { href: "javascript:void(0)" }
                },
                [
                  _c("b", [_vm._v("Filtra risultati")]),
                  _c("span", [_vm._v(" | " + _vm._s(_vm.counter))])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-secondary mr-3",
                  on: { click: _vm.onResetFilter }
                },
                [_vm._v("reset")]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      false && _vm.isFrom && _vm.isShowFlexibleDates
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.foundFlexibleDates,
                  expression: "foundFlexibleDates"
                }
              ],
              staticClass: "pl-3 flexible-date"
            },
            [
              _c("small", [_vm._v("Date Flessibili?")]),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.onOpenDateFlessibili }
                },
                [_vm._v("scopri alternative")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          on: {
            mouseleave: function($event) {
              _vm.openFilter = false
            }
          }
        },
        [
          _c("DropdownFilterFlight", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.openFilter,
                expression: "openFilter"
              }
            ],
            attrs: { value: _vm.filter, "is-from": _vm.isFrom },
            on: { change: _vm.onChangeFilter }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShowFlexibleDates && _vm.foundFlexibleDates
        ? _c("ModalFlexibleDates", { ref: "modalFlexyDate" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27317f05", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27317f05","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/volo-hotel/FilterFlightPanel.vue
// module id = null
// module chunks = 